export default __webpack_public_path__ + "static/media/recruitment-background.2920641a.jpg";